import Vue from 'vue';

const initialState = () => ({
  codigosBackup: [],
  palavraChave2FA: '',
  modalUsuarioLogado: false,
});

const state = initialState();

// Getters
const getters = {
  getCodigosBackup: (state) => state.codigosBackup,
  getPalavraChave2FA: (state) => state.palavraChave2FA || localStorage.getItem('palavraChave2FA') || '',
  getModalUsuarioLogado2FA: (state) => state.modalUsuarioLogado,
};

// Ações
const actions = {
  clearState({ commit }) {
    commit('RESET');
  },

  gerarQrCode({ commit }, { idUsuario, usuario, senhaUsuario }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const url = `/2fa/gerarQRCodeTOTP`;
      const body = { senhaUsuario };
      if (usuario) {
        body.usuario = usuario;
      } else if (idUsuario) {
        body.idUsuario = idUsuario;
      }

      const response = await api.send(
        url,
        'POST',
        body,
        undefined,
        false
      );

      if (response.status === 200) {
        resolve({
          status: 200,
          mensagem: response.data.mensagem,
          qrCode: response.data.dados.qrCode,
        });
      } else {
        resolve({
          status: response.status,
          mensagem: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
          qrCode: null,
        });
      }
    });
  },

  ativar2FA({ commit }, { idUsuario, usuario, senhaUsuario, codigoTOTP }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const url = `/2fa/ativar`;
      const body = { senhaUsuario, codigoTOTP };
      if (usuario) {
        body.usuario = usuario;
      } else if (idUsuario) {
        body.idUsuario = idUsuario;
      }

      const response = await api.send(
        url,
        'POST',
        body,
        undefined,
        false
      );

      if (response.status === 200) {
        commit('SET_CODIGOS_BACKUP', response.data.dados.codigosBackup);
        commit('SET_PALAVRA_CHAVE2FA', response.data.dados.palavraChave2FA);
        resolve({
          status: 200,
          mensagem: response.data.mensagem,
          codigosBackup: response.data.dados.codigosBackup,
          palavraChave2FA: response.data.dados.palavraChave2FA,
        });
      } else {
        commit('SET_CODIGOS_BACKUP', []);
        commit('SET_PALAVRA_CHAVE2FA', '');
        resolve({
          status: response.status,
          mensagem: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
          codigosBackup: null,
          palavraChave2FA: null,
        });
      }
    });
  },

  desativar2FA({ commit }, { idUsuario, usuario, senhaUsuario, codigoTOTP, codigoBackup }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const url = `/2fa/desativar`;
      const body = { senhaUsuario, codigoTOTP, codigoBackup };
      if (usuario) {
        body.usuario = usuario;
      } else if (idUsuario) {
        body.idUsuario = idUsuario;
      }

      const response = await api.send(
        url,
        'POST',
        body,
        undefined,
        false
      );

      if (response.status === 200) {
        resolve({
          status: 200,
          mensagem: response.data.mensagem,
        });
      } else {
        resolve({
          status: response.status,
          mensagem: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
        });
      }
    });
  },

  verificarAcaoCritica(
    { commit },
    { palavraChave2FA, codigoTOTP, acaoRequerida },
  ) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const url = `/2fa/verificarAcaoCritica`;
      const palavraChave = palavraChave2FA && String(palavraChave2FA).trim();

      if (!palavraChave) {
        resolve({
          status: 400,
          mensagem: 'Palavra-chave 2FA é obrigatória para esta operação.',
          tokenJWT2FA: null,
        });
        return;
      }

      const response = await api.send(
        url,
        'POST',
        {
          palavraChave2FA: palavraChave,
          codigoTOTP,
          acaoRequerida,
        },
        undefined,
        false
      );

      if (response.status === 200) {
        resolve({
          status: 200,
          mensagem: response.data.mensagem,
          tokenJWT2FA: response.data.dados.tokenJWT,
        });
      } else {
        resolve({
          status: response.status,
          mensagem: response.data.mensagem || 'Ocorreu um erro desconhecido durante sua requisição.',
          tokenJWT2FA: null,
        });
      }
    });
  },

  setarModalUsuarioLogado2FA({ commit }, estado) {
    commit('SET_MODAL_USUARIO_LOGADO_2FA', estado);
  },

  setPalavraChave2FA({ commit }, palavraChave2FA, setLocalStorage) {
    commit('SET_PALAVRA_CHAVE2FA', palavraChave2FA);
    
    if (setLocalStorage) {
      localStorage.setItem('palavraChave2FA', palavraChave2FA);
    }
  },

  carregarPalavraChave2FA({ commit, dispatch, rootGetters, state }) {
    return new Promise(async (resolve) => {
      const existente = state.palavraChave2FA || localStorage.getItem('palavraChave2FA') || '';
      if (existente && existente.trim()) {
        resolve({ status: 200, palavraChave2FA: existente.trim() });
        return;
      }

      const user = rootGetters['autenticacao/getUser'];
      const palavraDoPerfil = user?.autenticacao2FA?.palavraChave2FA || '';
      if (palavraDoPerfil && palavraDoPerfil.trim()) {
        commit('SET_PALAVRA_CHAVE2FA', palavraDoPerfil.trim());
        localStorage.setItem('palavraChave2FA', palavraDoPerfil.trim());
        resolve({ status: 200, palavraChave2FA: palavraDoPerfil.trim() });
        return;
      }

      const api = new Vue.prototype.$httpClient();
      const response = await api.send(
        '/2fa/palavra-chave',
        'GET',
        {},
        undefined,
        false
      );

      if (response.status === 200 && response.data.dados?.palavraChave2FA) {
        const palavraChave2FA = response.data.dados.palavraChave2FA.trim();
        commit('SET_PALAVRA_CHAVE2FA', palavraChave2FA);
        localStorage.setItem('palavraChave2FA', palavraChave2FA);

        if (user) {
          await dispatch(
            'autenticacao/setUser',
            {
              ...user,
              autenticacao2FA: {
                ...(user.autenticacao2FA || {}),
                palavraChave2FA,
              },
            },
            { root: true }
          );
        }

        resolve({ status: 200, palavraChave2FA });
        return;
      }

      resolve({
        status: response.status,
        palavraChave2FA: '',
        mensagem: response.data?.mensagem || 'Não foi possível carregar a palavra-chave 2FA.',
      });
    });
  },

  // Novas ações para operações críticas
  executarOperacaoCritica({ commit }, { operacao, tokenJWT, parametros }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const url = `/operacoes-criticas/executar`;
      const response = await api.send(
        url,
        'POST',
        {
          operacao,
          tokenJWT,
          parametros
        },
        undefined,
        false
      );

      if (response.status === 200) {
        resolve({
          status: 200,
          mensagem: response.data.mensagem,
          resultado: response.data.dados,
        });
      } else {
        resolve({
          status: response.status,
          mensagem: response.data.mensagem || 'Erro ao executar operação.',
          resultado: null,
        });
      }
    });
  },

  listarOperacoesCriticas({ commit }) {
    return new Promise(async (resolve) => {
      const api = new Vue.prototype.$httpClient();
      const url = `/operacoes-criticas/listar`;
      const response = await api.send(
        url,
        'GET',
        {},
        undefined,
        false
      );

      if (response.status === 200) {
        resolve({
          status: 200,
          operacoes: response.data.dados,
        });
      } else {
        resolve({
          status: response.status,
          mensagem: response.data.mensagem || 'Erro ao listar operações.',
          operacoes: [],
        });
      }
    });
  },
};

// Mutações
const mutations = {
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },

  SET_CODIGOS_BACKUP(state, codigosBackup) {
    state.codigosBackup = codigosBackup;
  },

  SET_PALAVRA_CHAVE2FA(state, palavraChave2FA) {
    state.palavraChave2FA = palavraChave2FA;
  },

  SET_MODAL_USUARIO_LOGADO_2FA(state, modalUsuarioLogado) {
    state.modalUsuarioLogado = modalUsuarioLogado;
  },
};

// Exportando módulo
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
